module.exports = __webpack_public_path__ + "static/media/bear_girl_winking.b2faf3bc.png";